import { createAsyncThunk } from '@reduxjs/toolkit';
import { EmailApi, SendDirectDepositEnrollmentFormEmailData } from 'api/EmailApi';

import { ErrorResponse } from './ErrorResponse';

export const createSendDirectDepositEnrollmentFormEmail = (api: EmailApi) =>
  createAsyncThunk(
    'payrollDeduction/sendEnrollmentFormEmail',
    async (data: SendDirectDepositEnrollmentFormEmailData, thunkApi) => {
      try {
        return await api.sendDirectDepositEnrollmentFormEmail(data);
      } catch (error: unknown) {
        thunkApi.rejectWithValue((error as ErrorResponse).response.data);

        throw error;
      }
    },
  );
